import { Routes, Route } from "react-router-dom";

import Login from "./components/Login/LoginForm";
import LocationSelect from "./components/Login/LocationSelect";
import Dashboard from "./components/Dashboard/Dashboard";
import ProtectedRoute from "./components/Route/ProtectedRoute";
import Equipmentinfo from "./components/Dashboard/DashboardEquipment/Equipmentinfo";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/location-select"
        element={
          <ProtectedRoute>
            <LocationSelect />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/equipment"
        element={
          <ProtectedRoute>
            <Equipmentinfo />
          </ProtectedRoute>
        }
      />
    </Routes>
     <ToastContainer />
     </>
  );
}

export default App;
